export const ActionIconSizeMap = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}
